// libraries
import React from 'react'

// dependencies
import { Select } from '@st-operations/uikit/src/v2/index.js'
import User from '../lib/User.js'

// style
import '../../css/components/SelectBox.styl'

// component
class SelectBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: undefined,
    }
  }

  componentDidMount() {
    let { entity, fields } = this.props
    if (entity && fields) {
      User.watch(this, (user) => {
        this.loadOptions()
      })
    }
  }

  loadOptions = () => {
    let { entity, fields } = this.props
    if (!fields) {
      fields = ['_id', 'name']
    }
    window._api.get(
      `/${entity}`,
      {
        fields,
        limit: 1000,
      },
      (error, resp) => {
        let items = resp.items.map((item) => {
          return {
            label: item.name,
            value: item._id,
          }
        })
        this.setState({ error, items })
      }
    )
  }

  render() {
    let { title, options, onChange, isMulti, value, isSearchable, show } = this.props
    let { items } = this.state
    if (items) {
      options = items
    }

    return (
      <div className={'query-row ' + (show ? 'show-box' : 'hide-box')}>
        <Select
          label={title}
          value={value}
          isMulti={isMulti}
          options={options}
          onChange={onChange}
          isSearchable={isSearchable}
          useReactSelect
        />
      </div>
    )
  }
}

// export
export default SelectBox
